export default __webpack_public_path__ + "static/media/DriveMobileActive.4d47fcb5.svg";